import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const DamExceptionCardContainer = styled.div<{ status: boolean, size?: 'fixed' | 'small' }>`
  height: 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  border: 1px solid #D7D7D7;
  border-left: 10px solid ${({ status }) => (status ? colors.brand.primary.base : colors.Grey200)};
  border-radius: 5px;
  margin-left: 10px;

  ${({ size }) => (size === 'fixed' ? `
    justify-content: space-between;
    margin-left: 0;
    width: auto;
  ` : `
    width: 709px;
  `)}
`;
